import React, { useState , useEffect} from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { connect, useDispatch, useSelector} from 'react-redux';
import { useLocation} from 'react-router-dom';
import { Formik } from 'formik';
//import { useStore } from 'react-redux'
import {
  Box,
  Button,
  Container,
  Grid,
  CircularProgress,
  Link,
  TextField,
  Typography,
  makeStyles,  
  
} from '@material-ui/core';
import Page from 'src/components/Page';
import { alertActions, userActions } from '../../_actions';
  const useStyles = makeStyles((theme) => ({
    root: {
      backgroundColor: theme.palette.background.dark,
      height: '100%',
      paddingBottom: theme.spacing(3),
      paddingTop: theme.spacing(3)
    }
  }));
function ForgotPassword() {
    const [submitted, setSubmitting] = useState(true);
    const classes = useStyles();
    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .email('Formato de Email inválido')
            .required('Email es requerido')
    });  

    return (
        <Page
        className={classes.root}
        title="Login"
      >     
        <Box
          display="flex"
          flexDirection="column"
          height="100%"
          justifyContent="center"
        >
          <Container maxWidth="sm">
             <Formik
              initialValues={{
                email: '',
               
              }}
              validationSchema={Yup.object().shape({
                email: Yup.string().email('El email no es valido').max(255).required('Email es requerido'),
              })}
           onSubmit={(values, actions) => {               
            //this.setState({ submitted: true });
           // const { username, password } = this.state;
            //setSubmitted(true);           
           if (values.email) {
           dispatch(userActions.forgotPassword(values.email));
            //.finally(() => setSubmitting(false));

            } 
         }}  
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                setSubmitted,
                touched,
                values
              }) => (
                <form onSubmit={handleSubmit}>
                  <Box mb={3}>
                    <Typography
                      color="textPrimary"
                      variant="h2"
                    >
                      Restaurar Contraseña
                    </Typography>                
                  </Box>
                  <Grid
                    container
                    spacing={3}
                  >  
                
                  </Grid>                
                  <TextField
                    error={Boolean(touched.email && errors.email)}
                    fullWidth
                    helperText={touched.email && errors.email}
                    label="Email"
                    margin="normal"
                    name="email"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="email"
                    value={values.email}
                    variant="outlined"
                  />                 
                  <Box my={2}>
                    <Button
                      color="primary"
                      disabled={setSubmitted}
                      fullWidth
                      size="large"
                      type="submit"
                      variant="contained"
                    >
                    <CircularProgress variant="determinate" value={setSubmitted} color="secondary" />
                      Aceptar
                    </Button>
                  </Box>
                  <Typography
                    color="textSecondary"
                    variant="body1"
                  >
                    ¿No tengo una cuenta?
                    {' '}
                    <Link
                      component={RouterLink}
                      to="/register"
                      variant="h6"
                    >
                      Registrarse
                      {',   '}
                    </Link>
                    <Link
                      component={RouterLink}
                      to="/login"
                      variant="h6"
                    >
                        Iniciar Sesión
                    </Link>
                  </Typography>
                

                </form>
              )}
            </Formik>
          </Container>
        </Box>
      </Page>
      )
}

export default ForgotPassword; 